export default __webpack_public_path__ + "fonts/poppins-latin-100-normal.9c2fa323c2d99d082f42.woff2";